import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { G99ColoredLogo } from '@g99-product-web-ui/shared-util-lib';
import { Subscription } from 'rxjs';

/**
 * Container component for managing authentication-related routes.
 * Tracks the current route and provides utilities for route-based logic.
 */
@Component({
  selector: 'g99-auth-container',
  templateUrl: './auth-container.component.html',
  styleUrl: './auth-container.component.scss',
  standalone: false,
})
export class AuthContainerComponent implements OnDestroy {
  /**
   * Stores the current route's last segment as a string, or `null` if no route is active.
   */
  public currentRoute: string | null = null;

  protected g99ColoredLogo = G99ColoredLogo;
  /**
   * Holds the subscription to the router events for route tracking.
   * This is unsubscribed in `ngOnDestroy` to prevent memory leaks.
   */
  private readonly _routerSubscription: Subscription;

  constructor(private readonly _router: Router) {
    this._routerSubscription = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this._router.url.split('/').pop() || null;
      }
    });
  }

  /**
   * Lifecycle hook called when the component is destroyed.
   * Unsubscribes from the router events to prevent memory leaks.
   */
  ngOnDestroy(): void {
    this._routerSubscription.unsubscribe();
  }

  /**
   * Checks if the given route matches the current route.
   * @param route - The route string to compare with the current route.
   * @returns `true` if the provided route matches the current route, otherwise `false`.
   */
  public isCurrentRoute(route: string): boolean {
    return this.currentRoute === route;
  }
}
